export default "__VITE_ASSET__DaPdAOHD__"